var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { DetectHoverSpan } from './tooltips';
// eslint-disable-next-line @typescript-eslint/no-namespace
export var GoalLocation;
(function (GoalLocation) {
    function isEqual(l1, l2) {
        if ('hyp' in l1)
            return 'hyp' in l2 ? l1.hyp === l2.hyp : false;
        else if ('hypType' in l1)
            return 'hypType' in l2 ? l1.hypType[0] === l2.hypType[0] && l1.hypType[1] === l2.hypType[1] : false;
        else if ('hypValue' in l1)
            return 'hypValue' in l2 ? l1.hypValue[0] === l2.hypValue[0] && l1.hypValue[1] === l2.hypValue[1] : false;
        else if ('target' in l1)
            return 'target' in l2 ? l1.target === l2.target : false;
        else
            return false;
    }
    GoalLocation.isEqual = isEqual;
    function withSubexprPos(l, p) {
        if ('hyp' in l)
            return l;
        else if ('hypType' in l)
            return { hypType: [l.hypType[0], p] };
        else if ('hypValue' in l)
            return { hypValue: [l.hypValue[0], p] };
        else if ('target' in l)
            return { target: p };
        else
            throw new Error("unrecognized GoalLocation variant ".concat(JSON.stringify(l)));
    }
    GoalLocation.withSubexprPos = withSubexprPos;
})(GoalLocation || (GoalLocation = {}));
// eslint-disable-next-line @typescript-eslint/no-namespace
export var GoalsLocation;
(function (GoalsLocation) {
    function isEqual(l1, l2) {
        return l1.mvarId === l2.mvarId && GoalLocation.isEqual(l1.loc, l2.loc);
    }
    GoalsLocation.isEqual = isEqual;
    function withSubexprPos(l, p) {
        return __assign(__assign({}, l), { loc: GoalLocation.withSubexprPos(l.loc, p) });
    }
    GoalsLocation.withSubexprPos = withSubexprPos;
})(GoalsLocation || (GoalsLocation = {}));
export var LocationsContext = React.createContext(undefined);
/**
 * A `<span>` with a corresponding {@link GoalsLocation} which can be (un)selected using shift-click.
 * If `locs` or `loc` is `undefined`, selection functionality is turned off. The element is also
 * highlighted when hovered over if `alwaysHighlight` is `true` or `locs` and `loc` are both defined.
 * `setHoverState` is passed through to {@link DetectHoverSpan}. */
export function SelectableLocation(props_) {
    var locs = props_.locs, loc = props_.loc, alwaysHighlight = props_.alwaysHighlight, setParentHoverState = props_.setHoverState, props = __rest(props_, ["locs", "loc", "alwaysHighlight", "setHoverState"]);
    var shouldHighlight = alwaysHighlight || (!!locs && !!loc);
    var _a = __read(React.useState('off'), 2), hoverState = _a[0], setHoverState = _a[1];
    var spanClassName = '';
    if (shouldHighlight) {
        spanClassName += 'highlightable ';
        if (hoverState !== 'off')
            spanClassName += 'highlight ';
        if (props.className)
            spanClassName += props.className;
    }
    var innerSpanClassName = 'highlightable '
        + (locs && loc && locs.isSelected(loc) ? 'highlight-selected ' : '');
    return React.createElement(DetectHoverSpan, __assign({}, props, { setHoverState: function (st) {
            setHoverState(st);
            if (setParentHoverState)
                setParentHoverState(st);
        }, className: spanClassName, onClick: function (e) {
            // On shift-click, if we are in a context where selecting subexpressions makes sense,
            // (un)select the current subexpression.
            if (e.shiftKey && locs && loc) {
                locs.setSelected(loc, function (on) { return !on; });
                e.stopPropagation();
            }
            if (props.onClick)
                props.onClick(e);
        }, onPointerDown: function (e) {
            // Since shift-click on this component is a custom selection, when shift is held prevent
            // the default action which on text is to start a text selection.
            if (e.shiftKey)
                e.preventDefault();
            if (props.onPointerDown)
                props.onPointerDown(e);
        } }),
        React.createElement("span", { className: innerSpanClassName }, props.children));
}
